export default __webpack_public_path__ + "static/media/user-image.75a04487.png";